import { ref, watch } from "vue";

// Singleton — shared UI state across Sidenav + DefaultLayout.
// Do not copy this pattern for domain data; it exists only because
// multiple components need to read and drive the same collapse state.

const STORAGE_KEY = "sb_sidenav_collapsed";
const DRAWER_MIN = 768;
const DRAWER_MAX = 1439;

function readPersisted(): boolean {
  if (typeof window === "undefined") return false;
  return window.localStorage.getItem(STORAGE_KEY) === "1";
}

const userPreference = ref<boolean>(readPersisted());
const isDrawerMode = ref<boolean>(false);
const isCollapsed = ref<boolean>(userPreference.value);

function updateDrawer(): void {
  const w = window.innerWidth;
  const wasDrawer = isDrawerMode.value;
  isDrawerMode.value = w >= DRAWER_MIN && w <= DRAWER_MAX;
  if (isDrawerMode.value && !wasDrawer) {
    isCollapsed.value = true;
  }
  if (!isDrawerMode.value && wasDrawer) {
    isCollapsed.value = userPreference.value;
  }
}

function toggle(): void {
  isCollapsed.value = !isCollapsed.value;
  if (!isDrawerMode.value) {
    userPreference.value = isCollapsed.value;
  }
}

if (typeof window !== "undefined") {
  updateDrawer();
  window.addEventListener("resize", updateDrawer);
}

watch(userPreference, (v) => {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, v ? "1" : "0");
});

export function useSidenavCollapse() {
  return { isCollapsed, isDrawerMode, toggle };
}
